import React from "react";
import Card from "../../../shared/components/Card";

const CenterInfo = ({ center }) => {
  const percentage = center?.occupancy?.percentage || 0;

  return (
    <div>
      <Card>
        <h2 className="text-lg font-semibold mb-4">Center Information</h2>

        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-700">Center Type</p>
            <p className="text-lg font-semibold capitalize">{center?.type}</p>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-700">Occupancy</p>

            <div className="mt-2">
              <div className="flex justify-between text-sm mb-1">
                <span>
                  {center?.occupancy?.current} / {center?.occupancy?.capacity}
                </span>

                <span className="font-medium">{percentage}%</span>
              </div>

              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${
                    percentage > 80
                      ? "bg-red-500"
                      : percentage > 60
                      ? "bg-yellow-500"
                      : "bg-green-500"
                  }`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default React.memo(CenterInfo);